import { formatMoney, type Column } from '@platform/design-system';
import { usePageContext } from '../usePageContext.ts';
import type { HandoverParcel } from './handover.ts';
import styles from './Handover.module.css';
import { TrackingCode } from '../TrackingCode.tsx';

export const useParcelColumns = (): readonly Column<HandoverParcel>[] => {
  const { t, locale } = usePageContext();
  return [
    {
      id: 'tracking',
      header: t('handover.trackingNumber'),
      primary: true,
      cell: (row) => <TrackingCode code={row.trackingNumber} />,
    },
    { id: 'order', header: t('handover.order'), cell: (row) => row.orderNumber },
    { id: 'recipient', header: t('handover.recipient'), cell: (row) => row.recipientName },
    { id: 'phone', header: t('handover.phone'), cell: (row) => <bdi dir="ltr">{row.phone}</bdi> },
    { id: 'place', header: t('handover.place'), cell: (row) => row.place },
    {
      id: 'amount',
      header: t('handover.amount'),
      numeric: true,
      cell: (row) => <span className={styles['amount']}>{formatMoney(row.codAmount, locale)}</span>,
    },
  ];
};
